import { useEffect } from "react";
import { getCreateModeFeatureSettingsReset } from "../utils/companyFeatureSettings";

// Creating a company (no company loaded or named): no previous company's
// feature settings, nor edits made against them, carry over into the form.
export const useCreateModeFeatureSettingsReset = ({
  companyData,
  resolvedCompanyId,
  form,
  hydrateForm,
}) => {
  useEffect(() => {
    if (companyData || resolvedCompanyId) return;
    const resetPatch = getCreateModeFeatureSettingsReset(form);
    if (resetPatch) hydrateForm(resetPatch);
  }, [companyData, form, hydrateForm, resolvedCompanyId]);
};
